import _ from "lodash";
import React from "react";
import { FormService } from "../../services/form-service";
import { IWithSDProps, withSD } from "../../shared/hoc/screen-design-consumer";
import { KMainFunctions } from "../../shared/utility/main-functions";
import { KModal } from "../ui-kit/k-modal/k-modal";
import { KModalFooter } from "../ui-kit/k-modal/k-modal-footer";
import KuikaModalIconWrapper from "../ui-kit/kuika-modal-icon-wrapper/kuika-modal-icon-wrapper";
import KuikaSelectbox, { KuikaSelectboxOption } from "../ui-kit/kuika-selectbox/kuika-selectbox";
import KuikaH5 from "../ui-kit/typography/H5/H5";
import KuikaSmallText from "../ui-kit/typography/SmallText/SmallText";
import "./pick-process-modal.scss";

export interface IPickProcessModalProps {}

export interface IPickProcessModalState {
  selectedProcess: string;
  isLoading: boolean;
}

class PickProcessModal extends React.PureComponent<IPickProcessModalProps & IWithSDProps, IPickProcessModalState> {
  static initialState: IPickProcessModalState = {
    selectedProcess: "",
    isLoading: false
  };

  constructor(props) {
    super(props);
    this.state = { ...PickProcessModal.initialState };
  }

  onClose = () => {
    this.setState({ ...PickProcessModal.initialState });
    this.props.sd.setIsPickProcessModalOpen(false);
  };

  onClickOk = async () => {
    try {
      if (_.isEmpty(this.state.selectedProcess) || !this.props.sd.targetKuikaIdForCreateElementForAction) {
        return;
      }

      const wf = this.props.sd.workFlowList.find((wf) => wf.id === this.state.selectedProcess);

      if (!wf) {
        return;
      }

      if (wf.parameters && wf.parameters.filter((p) => p.isInput === true).length <= 0) {
        KMainFunctions.displayWarningNotification(
          "This process does not have any input parameters. Please select another process."
        );
        return;
      }

      this.setState({ isLoading: true });

      const response = await FormService.GetFormMetadataForStartProcess({
        processId: this.state.selectedProcess
      });

      if (response.status !== 200) {
        return;
      }

      const formMetadata = response.data;

      const createFormResponse = await FormService.GetFormDiCustom({
        projectId: this.props.sd.project.id,
        ...formMetadata
      });

      if (createFormResponse.status !== 200) {
        return;
      }

      this.props.sd.injectDiToTargetDi({
        displayItem: createFormResponse.data,
        targetKuikaId: this.props.sd.targetKuikaIdForCreateElementForAction
      });

      setTimeout(() => {
        this.props.sd.setSelectedDisplayItem(createFormResponse.data.id.toString());
      }, 200);

      this.onClose();
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
    } finally {
      this.setState({ isLoading: false });
    }
  };

  render() {
    return (
      <KModal
        showModal
        closeModal={this.onClose}
        header="Select Process"
        width={460}
        centered
        isLoading={this.state.isLoading}
        footer={
          <KModalFooter
            onCancel={this.onClose}
            cancelTestId="pickProcessCancelButton"
            submitLabel="OK"
            submitTestId="pickProcessOkButton"
            onSubmit={this.onClickOk}
            disabled={_.isEmpty(this.state.selectedProcess)}
          />
        }
      >
        <div className="kuika-pick-process">
          <div className="kuika-pick-process__header">
            <KuikaModalIconWrapper iconName="route-square-2" intent="neutral" />
            <div className="kuika-pick-process__title">
              <KuikaH5>Select Process</KuikaH5>
              <KuikaSmallText className="kuika-pick-process__label">Select a process to start</KuikaSmallText>
            </div>
          </div>
          <KuikaSelectbox
            data-testid="pickProcessSelect"
            placeholder="Select a process"
            value={this.state.selectedProcess || undefined}
            onChange={(value: string) => this.setState({ selectedProcess: value })}
            searchable
            size="md"
            options={this.props.sd.workFlowList.map((process): KuikaSelectboxOption => ({
              key: process.id,
              value: process.id,
              label: process.name
            }))}
          />
        </div>
      </KModal>
    );
  }
}

const pickProcessModal = withSD<IPickProcessModalProps>(PickProcessModal);
export { pickProcessModal as PickProcessModal };
